var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list",
    [
      _vm._l(_vm.venduto, function (vend, i) {
        return [
          i > 0 ? _c("v-divider", { key: "d_" + i }) : _vm._e(),
          _c("ItemListVenduto", { key: vend.id, attrs: { item: vend } }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }